import { type OrderDraftItemApiModel } from '../api-models/OrderDraftItemApiModel'
import { type OrderItemApiModel } from '../api-models/OrderItemApiModel'

export const mapOrderItemRecurringDetails = (
  recurringItemData:
    | OrderDraftItemApiModel['recurrence']
    | OrderItemApiModel['recurrence']
) => {
  if (!recurringItemData) return null

  return {
    startDate: recurringItemData.start_date,
    frequency: recurringItemData.frequency,
    duration: recurringItemData.duration,
    durationQuantity: recurringItemData.duration_quantity,
    recurringPrice: recurringItemData.recurring_price,
    periodsCount: recurringItemData.periods_count,
  }
}
